import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

export enum ButtonVariation {
  ICON_ONLY = 'button icon-only',
  ICON_ONLY_ROUNDED = 'button icon-only icon-rounded',
  ICON_ONLY_ROUNDED_DARK = 'button icon-only icon-rounded dark',
  ICON_ONLY_ROUNDED_DARK_BORDER = 'button icon-only icon-rounded dark border',
  LINK = 'button link',
  LINK_SECONDARY = 'button link link-secondary',
  PRIMARY = 'button primary',
  PRIMARY_OUTLINED = 'button primary-outlined',
  PRIMARY_OUTLINED_ICON = 'button primary-outlined icon',
}

export enum ButtonSize {
  TINY = 'tiny',
  SMALL = 'small',
  REGULAR = 'regular',
  LARGE = 'large',
}

interface Props {
  children: React.ReactNode;
  className?: string;
  contentAfter?: React.ReactNode;
  contentBefore?: React.ReactNode;
  disabled?: boolean;
  href?: string;
  isExternal?: boolean;
  onClick?: () => void;
  size?: ButtonSize;
  type?: 'link' | 'button' | 'submit';
  variation?: ButtonVariation;
  wide?: boolean;
}

const Button: React.FC<Props> = ({
  children,
  contentAfter,
  contentBefore,
  className,
  disabled,
  href,
  isExternal = false,
  onClick,
  size = ButtonSize.REGULAR,
  type = 'button',
  variation,
  wide,
}) => {
  return (
    <>
      {type !== 'link' && (
        <button
          type={type}
          onClick={onClick}
          disabled={disabled}
          className={classNames(
            {
              'icon-content': !!contentAfter || !!contentBefore,
              disabled,
              wide,
            },
            size,
            variation,
            className
          )}
        >
          {contentBefore}
          {children}
          {contentAfter}
        </button>
      )}
      {type === 'link' && !isExternal && (
        <Link
          type={type}
          onClick={onClick}
          to={href ? href : '#'}
          target={isExternal ? '_blank' : '_self'}
          className={classNames(
            {
              'icon-content': !!contentAfter || !!contentBefore,
              disabled,
              wide,
            },
            size,
            variation,
            className
          )}
          rel="noreferrer"
        >
          {contentBefore}
          {children}
          {contentAfter}
        </Link>
      )}
      {type === 'link' && isExternal && (
        <a
          type={type}
          onClick={onClick}
          href={href ? href : '#'}
          target={isExternal ? '_blank' : '_self'}
          className={classNames(
            {
              'icon-content': !!contentAfter || !!contentBefore,
              disabled,
              wide,
            },
            size,
            variation,
            className
          )}
          rel="noreferrer"
        >
          {contentBefore}
          {children}
          {contentAfter}
        </a>
      )}
    </>
  );
};

export default Button;
